import { NETWORK_OPTS } from "../../config/strings";

export const CustomFilters = [
    {
    fieldName: "max_distance",
    title: "Mileage",
    filterType: "SingleValueSliderFilter",
    defaultValue: 25,
    validation: "number",
    minValue:1,
    maxValue: 200,
    setToDefaultOnClear:true,
    activeChip: {
      isActive: true,
      label: "",
    },
    },
    {
    fieldName: "day",
    title: "Day Of Availability",
    filterType: "SingleSelect",
    nameKey: "label",
    valueKey: "key",
    orderingVal: "order",
    apiUrl: `field_options/?content_type=providerofficehours&field_name=day&flat=true&`,
    permission: "",
  },
  {
    fieldName: "time",
    title: "Time Of Availability",
    filterType: "TimePicker",
    permission: "",
  },
  {
    fieldName: "in_network_receiving",
    title: "Network Status",
    filterType: "SingleSelect",
    nameKey: "name",
    valueKey: "value",
    orderingVal: "",
    permission: "",
    fetchFromAPI: false,
    staticData: NETWORK_OPTS,
    defaultValue:1,
    activeChip: {
      isActive: true,
      label: "",
    },
    hideClearBtn: true,
  }
];
